import { usePoints, useT } from '../../i18n';
import { naechsterOffener } from '../../domain/naechster';
import { requireCandidate, useAppStore } from '../../store/useAppStore';
import { Dialog } from '../../ui/Dialog';
import { Icon } from '../../ui/Icon';
import styles from './Submit.module.css';

/**
 * Bestätigung nach dem Absenden. Der Bogen dahinter bleibt sichtbar, aber gesperrt —
 * er dient noch zur Kontrolle, soll sich aber nicht mehr ändern lassen.
 */
export function LockedDialog() {
  const t = useT();
  const points = usePoints();
  const candidate = useAppStore(requireCandidate);
  const record = useAppStore((s) => s.submitted[s.candidateId]);
  const openSheet = useAppStore((s) => s.openSheet);
  const goToNext = useAppStore((s) => s.goToNextCandidate);
  const zuerstScannen = useAppStore((s) => s.afterSubmit.scanner);
  const exam = useAppStore((s) => s.exam);
  const abgesendet = useAppStore((s) => s.submitted);
  const naechster = exam ? naechsterOffener(exam.candidates, abgesendet, candidate.id) : null;
  const summeZeigen = useAppStore((s) => s.bogenAnzeige.summe);
  const closeSheet = useAppStore((s) => s.closeSheet);

  if (!record) return null;

  return (
    <Dialog kicker={t.locked.kicker} title={t.locked.title} onClose={closeSheet} width={600}>
      <div className={styles.lockedHead} style={{ marginTop: 14 }}>
        <span className={styles.lockedMark}>
          <Icon name="check" size={22} />
        </span>
        <div>
          <div className={styles.lockedTitle}>{candidate.name}</div>
          <div className={styles.lockedMeta}>
            {summeZeigen
              ? t.locked.meta(points(record.total), points(record.max), record.at)
              : t.locked.metaOhnePunkte(record.at)}
          </div>
        </div>
      </div>

      <div className={styles.lockedNote}>
        {t.locked.note}
      </div>

      {/*
        * `next_candidate_button` (seit 2026-10-02 mit Wirkung): bei `next` wird der direkte
        * Wechsel zum nächsten offenen Prüfling der Hauptknopf — sein Name steht darauf —, der
        * QR-Scanner der zweite. Bei `scan` und wenn niemand mehr offen ist, bleibt es wie bisher:
        * Scanner und Liste.
        */}
      <div className={styles.lockedButtons}>
        {!zuerstScannen && naechster ? (
          <>
            <button
              type="button"
              className={`tap ${styles.lockedPrimary}`}
              onClick={() => void goToNext()}
            >
              <Icon name="arrowRight" size={16} />
              <span>{t.locked.next(naechster.name)}</span>
            </button>
            <button
              type="button"
              className={`tap ${styles.lockedSecondary}`}
              onClick={() => openSheet({ kind: 'scanner' })}
            >
              <Icon name="qr" size={16} />
              <span>{t.locked.scanNext}</span>
            </button>
          </>
        ) : (
          <>
            <button
              type="button"
              className={`tap ${styles.lockedPrimary}`}
              onClick={() => openSheet({ kind: 'scanner' })}
            >
              <Icon name="qr" size={16} />
              <span>{t.locked.scanNext}</span>
            </button>
            <button
              type="button"
              className={`tap ${styles.lockedSecondary}`}
              onClick={() => openSheet({ kind: 'candidates' })}
            >
              <Icon name="list" size={16} />
              <span>{t.locked.fromList}</span>
            </button>
          </>
        )}
      </div>
    </Dialog>
  );
}
